define('plugin/promotion/view/PromotionInvoiceInstanceItemView',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Promotion invoice instance item view
     *
     * @class PromotionInvoiceInstanceItemView
     */
    return Marionette.ItemView.extend({

        template: '#promotion_invoice_instance_item_view',
        ui: {
            'removeBtn': '.sb-remove-promotion'
        },
        triggers: {
            'click @ui.removeBtn': 'remove:promotion'
        },

        serializeData: function () {
            return _.extend(Marionette.ItemView.prototype.serializeData.apply(this), {
                'allow_edit': this.getOption('allowEdit')
            });
        }

    });

});
